/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS0Icon20Light = forwardRef('MediaAudioVolumeS0Icon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.346 2.086A1 1 0 0 1 11 2.842v14.316a1 1 0 0 1-1.654.756l-4.462-3.853A.25.25 0 0 0 4.721 14H1.75A1.75 1.75 0 0 1 0 12.25v-4.5C0 6.783.784 6 1.75 6h2.971a.25.25 0 0 0 .163-.06l4.462-3.854Zm.654.756L5.538 6.696A1.25 1.25 0 0 1 4.721 7H1.75a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h2.971c.3 0 .59.108.817.304L10 17.157V2.842Z" })));
});
